<form (ngSubmit)="onSubmit()" class="flex flex-row p-1 text-left border border-gray-800 border-solid bg-gray-900">
  <span class="p-1 bg-gray-800 border border-gray-800 border-solid">System</span>
  <span class="w-20 p-1 mr-1 text-center bg-black border border-gray-800 border-solid">{{ x }}|{{ y }}</span>
  
  <span class="p-1 bg-gray-800 border border-gray-800 border-solid">Objekte</span>
  <span class="w-16 p-1 mr-1 text-center bg-black border border-gray-800 border-solid">{{ scan ? scan.scanObjects.length : 0 }}</span>
  
  <ng-container *ngIf="scan">
    <span class="p-1 bg-gray-800 border border-gray-800 border-solid">Aktualisiert</span>
    <span class="p-1 mr-1 bg-black border border-gray-800 border-solid text-sm">{{ scan.updatedAt | date:'dd.MM.yyyy HH:mm' }}</span>
    
    <span class="p-1 bg-gray-800 border border-gray-800 border-solid">Erstellt</span>
    <span class="p-1 mr-1 bg-black border border-gray-800 border-solid text-sm">{{ scan.createdAt | date:'dd.MM.yyyy HH:mm' }}</span>
  </ng-container>

  <span class="flex-grow bg-gray-800"></span>

  <label class="px-2 py-1 ml-1 bg-gray-800 border border-gray-800 border-solid">X</label>
  <input class="w-12 px-2 py-1 mr-1 text-center text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300" 
         type="text" [(ngModel)]="inputX" name="inputX" (change)="onInputChange()">

  <label class="px-2 py-1 bg-gray-800 border border-gray-800 border-solid">Y</label>
  <input class="w-12 px-2 py-1 mr-1 text-center text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300" 
         type="text" [(ngModel)]="inputY" name="inputY" (change)="onInputChange()">
  
  <button type="submit" class="px-2 py-1 mr-1 bg-gray-800 border border-white border-solid hover:border-orange-300 hover:text-orange-300">
    Anzeigen
  </button>
</form>
